import { render, staticRenderFns } from "./StudentInfomation.vue?vue&type=template&id=24b60658&"
import script from "./StudentInfomation.vue?vue&type=script&lang=js&"
export * from "./StudentInfomation.vue?vue&type=script&lang=js&"
import style0 from "./StudentInfomation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports